module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"contains_overall":"Contains overall","and_notably_sources":"And notably sources","and_no_sources":"And notably no sources.","project_administrators":"Project administrators:"},"fr":{"contains_overall":"Comptabilise en tout","and_notably_sources":"Et notamment les sources","and_no_sources":"Et notamment aucune source.","project_administrators":"Administrateurs du projet :"}}')
  delete Component.options._Ctor
}
